/* eslint-disable react-hooks/exhaustive-deps */
import React, {FC, useEffect, useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import {Link, useLocation, useNavigate, useParams} from 'react-router-dom'
import {
  setIsThereNonSavedForm,
  setProjectActiveTabAll,
} from '../../common/ModalPopup/reducer'
import clsx from 'clsx'
import ButtonX from '../../modules/apps/project/components/ButtonX/ButtonX'
import {useThemeMode} from '../../../_metronic/partials/layout/theme-mode/ThemeModeProvider'
import {Modal} from 'react-bootstrap'

type NPProps = {
  isTab2Active?: boolean
  isTab3Active?: boolean
  isTab4Active?: boolean
  isTab5Active?: boolean
  dType?: 'small' | 'large'
}

const NewProjectHeader: FC<NPProps> = ({
  isTab2Active,
  isTab3Active,
  isTab4Active,
  isTab5Active,
  dType = 'large',
}) => {
  const location = useLocation()
  const intl = useIntl()
  const {mode} = useThemeMode()
  const {pGuid} = useParams()
  const projectData = useSelector((state: any) => state.projectData)
  const projectEditing = useSelector((state: any) => state.projectEditing)
  const isThereNonSavedForm = useSelector((state: any) => state?.isThereNonSavedForm)
  const [showCancel, setShowCancel] = useState<boolean>(false)
  const [w2go, setW2go] = useState<string>('')
  const dispatch = useDispatch()
  const navigate = useNavigate()
  useEffect(() => {
    if (pGuid) {
      dispatch(setProjectActiveTabAll(null))
    }
  }, [pGuid])
  const onTab1 = useMemo(() => {
    if (pGuid) {
      return `/new-project/tab1/${pGuid}`
    }
    return '/new-project/tab1'
  }, [pGuid, projectData.tab1])

  const onTab2 = useMemo(() => {
    if (projectData.tab2.disabled) return '#'
    if (pGuid) {
      return `/new-project/tab2/${pGuid}`
    }
    return '/new-project/tab2'
  }, [pGuid, projectData.tab2])

  const onTab3 = useMemo(() => {
    if (projectData.tab3.disabled) return '#'
    if (pGuid) {
      return `/new-project/tab3/${pGuid}`
    }
    return '/new-project/tab3'
  }, [pGuid, projectData.tab3])

  const onTab4 = useMemo(() => {
    if (projectData.tab4.disabled) return '#'
    if (pGuid) {
      return `/new-project/tab4/${pGuid}`
    }
    return '/new-project/tab4'
  }, [pGuid, projectData.tab4])

  const onTab5 = useMemo(() => {
    if (projectData.tab5.disabled && !pGuid) return '#'
    if (pGuid) {
      return `/new-project/tab5/${pGuid}`
    }
    return '/new-project/tab5'
  }, [pGuid, projectData.tab5])

  const checkEditNonSaved = (e: any, routeName: string) => {
    setW2go(routeName)
    if (isThereNonSavedForm === true) {
      setShowCancel(true)
    } else {
      navigate(routeName)
    }
  }

  const onCancelReset = () => {
    setShowCancel(false)
  }

  const onConfirmCancel = () => {
    setShowCancel(false)
    dispatch(setIsThereNonSavedForm(false));
    navigate(w2go)
  }

  return (
    <div className='position-relative'>
      <ButtonX />
      <div
        className='d-flex align-items-end justify-content-center w-100 px-4 position-relative pt-4'
        style={{zIndex: 8}}
      >
        <ul
          className={
            'd-flex nav justify-content-center justify-content-center nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder ' +
            (dType === 'small' ? ' flex-wrap ' : ' flex-nowrap ')
          }
        >
          <li
            className='nav-item mb-3'
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Link
              className={clsx('me-6 ', {
                'active ': location.pathname.indexOf('tab1') !== -1,
                'text-hover-primary text-active-primary nav-link':
                  !projectData.tab1.disabled || pGuid,
              })}
              to={onTab1}
              style={{
                cursor: projectData.tab1.disabled && !pGuid ? 'not-allowed' : 'pointer',
                color: projectData.tab1.disabled && !pGuid && '#A1A5B7',
                borderBottomWidth: 2,
                padding: '0.5rem 0',
                margin: '0 1rem',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              onClick={(e) => {
                e.preventDefault()
                checkEditNonSaved(e, onTab1)
              }}
            >
              {intl.formatMessage({id: 'THE_CONSTRUCT'})}
            </Link>
          </li>
          <li
            className='nav-item mb-3'
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Link
              className={clsx('me-6 ', {
                'active ': location.pathname.indexOf('tab2') !== -1,
                'text-hover-primary text-active-primary nav-link':
                  !projectData.tab2.disabled || pGuid,
              })}
              to={onTab2}
              style={{
                cursor: projectData.tab2.disabled && !pGuid ? 'not-allowed' : 'pointer',
                color: projectData.tab2.disabled && !pGuid && '#A1A5B7',
                borderBottomWidth: 2,
                padding: '0.5rem 0',
                margin: 'auto 1rem',
              }}
              onClick={(e) => {
                e.preventDefault()
                checkEditNonSaved(e, onTab2)
              }}
            >
              {intl.formatMessage({id: 'THE_PROJECT'})}
            </Link>
          </li>

          <li
            className='nav-item mb-3'
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Link
              className={clsx('me-6', {
                active: location.pathname.indexOf('tab3') !== -1,
                'text-hover-primary text-active-primary nav-link':
                  !projectData.tab3.disabled || pGuid,
              })}
              to={onTab3}
              style={{
                cursor: projectData.tab3.disabled && !pGuid ? 'not-allowed' : 'pointer',
                color: projectData.tab3.disabled && !pGuid && '#A1A5B7',
                borderBottomWidth: 2,
                padding: '0.5rem 0',
                margin: '0 1rem',
              }}
              onClick={(e) => {
                e.preventDefault()
                checkEditNonSaved(e, onTab3)
              }}
            >
              {intl.formatMessage({id: 'COND_OF_USE'})}
            </Link>
          </li>
          <li
            className='nav-item mb-3'
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Link
              className={clsx('me-6', {
                active: location.pathname.indexOf('tab4') !== -1,
                'text-hover-primary text-active-primary nav-link':
                  !projectData.tab4.disabled || pGuid,
              })}
              to={onTab4}
              style={{
                cursor: projectData.tab4.disabled && !pGuid ? 'not-allowed' : 'pointer',
                color: projectData.tab4.disabled && !pGuid && '#A1A5B7',
                borderBottomWidth: 2,
                padding: '0.5rem 0',
                margin: '0 1rem',
              }}
              onClick={(e) => {
                e.preventDefault()
                checkEditNonSaved(e, onTab4)
              }}
            >
              {intl.formatMessage({id: 'PRESTATIONS'})}
            </Link>
          </li>
          <li
            className={`nav-item mb-3 `}
            style={{
              alignItems: 'center',
              justifyContent: 'center',
              display: 'flex',
            }}
          >
            <Link
              className={clsx('me-6 ', {
                active: location.pathname.indexOf('tab5') !== -1,
                'text-hover-primary text-active-primary nav-link':
                  !projectData.tab5.disabled || pGuid,
              })}
              to={onTab5}
              style={{
                cursor: projectData.tab5.disabled && !pGuid ? 'not-allowed' : 'pointer',
                color: projectData.tab5.disabled && !pGuid && '#A1A5B7',
                borderBottomWidth: 2,
                padding: '0.5rem 0',
                margin: '0 1rem',
              }}
              onClick={(e) => {
                e.preventDefault()
                checkEditNonSaved(e, onTab5)
              }}
            >
              {intl.formatMessage({id: 'PROPOSAL'})}
            </Link>
          </li>
        </ul>
      </div>
      {projectEditing?.ProjectTitle && (
        <div
          className={`d-flex align-items-center justify-content-center py-1 text-dark-600`}
          style={{
            backgroundColor: mode === 'dark' ? '#2C2C2C' : '#e1e3ea',
            fontSize: '1.3em',
          }}
        >
          {projectEditing?.ProjectTitle}
        </div>
      )}
      <Modal show={showCancel} centered>
        <div className='text-center p-5 w-100' data-bs-theme={mode}>
          <div
            className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
            data-bs-theme={mode}
          >
            <div className='d-flex align-items-center justify-content-between'>
              <div className='fw-bolder text-gray-700 py-3'>
                {intl.formatMessage({id: 'INFORMATION'})}
              </div>
              <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                <i className='fa fa-close text-danger'></i>
              </div>
            </div>
            <div className={'text-start py-3'}>
              <div>{intl.formatMessage({id: 'BEFORE_QUIT_CONFIRM_MESSAGE'})}</div>
            </div>
            <div className='d-flex align-items-center justify-content-evenly'>
              <button className={'btn btn-secondary'} onClick={onCancelReset}>
                {intl.formatMessage({id: 'NO'})}
              </button>
              <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                {intl.formatMessage({id: 'YES'})}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default NewProjectHeader
